export default __webpack_public_path__ + "static/B0163-094ac85fb496d1ba04bc661deced3da4.png";